import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API_BASE, timeout: 15000 });
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("sv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const adminApi = {
  listUsers:    (params) => client.get(`/admin/users`, { params }),
  listPending:  () => client.get(`/admin/users/pending`),
  approve:      (id, note = "")   => client.post(`/admin/users/${id}/approve`,    { note }),
  reject:       (id, reason)      => client.post(`/admin/users/${id}/reject`,     { reason }),
  suspend:      (id, reason)      => client.post(`/admin/users/${id}/suspend`,    { reason }),
  reactivate:   (id, note = "")   => client.post(`/admin/users/${id}/reactivate`, { note }),
  promote:      (id, note = "")   => client.post(`/admin/users/${id}/promote`,    { note }),
  demote:       (id, note = "")   => client.post(`/admin/users/${id}/demote`,     { note }),
  audit:        (params) => client.get(`/admin/audit`, { params }),
};
